import React, { useState, useRef } from 'react';
import SectionTitle from '../../../components/section-title';
import CustomImage from '../../../components/custom-image';
import ScrollPositionAnimation from '../../../components/scrollpositionanimation';
import useOutsideClick from '../../../utils/useOutsideClick';

const WellStructuredDeliver = () => {
  const wrapperRef = useRef(null);
  const [showImage, setShowImage] = useState(false);

  useOutsideClick(wrapperRef, () => {
    setShowImage(false);
  });
  return (
    <div className="well-structured-deliver">
      <div className="container">
        <div className="container-inner">
          <ScrollPositionAnimation targetElement2="anim-12">
            <div className="bottom-to-top anim-12">
              <div className="content-row">
                <div className="column">
                  <SectionTitle
                    lighttext="WELL-STRUCTURED TO DELIVER"
                    boldtext="VALUE-ACCRETIVE GROWTH"
                    isSectionH1={false}
                  ></SectionTitle>
                  <div className="image-box">
                    <div className="desktop-img">
                      <CustomImage
                        className="custom-image"
                        imageName="well-structured-deliver.png"
                        alt="Well Structured To Deliver"
                        maxWidth="1200"
                      />
                    </div>
                    <div className="mobile-img">
                      <button ref={wrapperRef} className="table-popup" onClick={() => setShowImage(!showImage)}>
                        <CustomImage
                          className="custom-image"
                          imageName="icon-info-b.svg"
                          alt="Info Icon"
                          maxWidth="24"
                        />
                      </button>
                      {showImage && (
                        <div className="show-img">
                          <CustomImage
                            className="custom-image"
                            imageName="well-structured-deliver-popup.png"
                            alt="Well Structured To Deliver"
                            maxWidth="293"
                          />
                        </div>
                      )}
                      <CustomImage
                        className="custom-image"
                        imageName="well-structured-deliver-mobile.png"
                        alt="Well Structured To Deliver"
                        maxWidth="340"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ScrollPositionAnimation>
        </div>
      </div>
    </div>
  );
};

export default WellStructuredDeliver;
